/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerDeleteMutationResponse,
  TelegramUsersControllerDelete401,
} from '../types/TelegramUsersControllerDelete.ts';

function getTelegramUsersDeleteUrl() {
  const res = { method: 'DELETE', url: `/api/telegram/users` as const };
  return res;
}

/**
 * {@link /api/telegram/users}
 */
export async function telegramUsersDelete(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramUsersControllerDeleteMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerDelete401>,
    unknown
  >({ method: 'DELETE', url: getTelegramUsersDeleteUrl().url.toString(), ...requestConfig });
  return res.data;
}
